import { useGetOpenRouterKeyQuery } from "@generated";
import { RootState } from "@reducers/rootReducer";
import { useSelector } from "react-redux";
import { OpenRouterKeyFormState } from "../types";

const useGetOpenRouterKey = (id: string) => {
  const { accountSlug } = useSelector((state: RootState) => state.slug);
  const { data, error, isLoading, refetch } = useGetOpenRouterKeyQuery({
    slug: accountSlug,
    id: id as unknown as number,
  });

  let openRouterKey: OpenRouterKeyFormState | null = null;
  let customError: string | null = null;

  if (data?.data) {
    try {
      const resource = data.data;
      if (!resource.id) {
        throw new Error("Missing open router key id");
      }

      const attrs = resource.attributes as Record<string, string> | undefined;
      if (!attrs) {
        throw new Error("Missing attributes");
      }

      openRouterKey = {
        id: String(resource.id),
        name: attrs["name"] || "",
        llms: Array.isArray(attrs["llms"]) ? attrs["llms"] : [],
        keyType: (attrs["key-type"] as OpenRouterKeyFormState["keyType"]) || "",
        // Azure
        modelSlug: attrs["model-slug"] || "",
        endpointUrl: attrs["endpoint-url"] || "",
        apiKey: attrs["api-key"] || "",
        modelId: attrs["model-id"] || "",
        // AWS Bedrock
        key: attrs["key"] || "",
        accessKeyId: attrs["access-key-id"] || "",
        secretAccessKey: attrs["secret-access-key"] || "",
        region: attrs["region"] || "",
        // Google Vertex
        modelType: attrs["model-type"] || "",
        projectId: attrs["project-id"] || "",
        privateKeyId: attrs["private-key-id"] || "",
        privateKey: attrs["private-key"] || "",
        clientEmail: attrs["client-email"] || "",
        clientId: attrs["client-id"] || "",
        authUri: attrs["auth-uri"] || "",
        tokenUri: attrs["token-uri"] || "",
        authProviderX509CertUrl: attrs["auth-provider-x509-cert-url"] || "",
        clientX509CertUrl: attrs["client-x509-cert-url"] || "",
        universeDomain: attrs["universe-domain"] || "",
      };
    } catch (err) {
      if (err instanceof Error) {
        customError = err.message;
      } else {
        customError = "An unknown error occurred";
      }
    }
  }

  return {
    openRouterKey,
    error: error || customError,
    isLoading,
    refetch,
  };
};

export default useGetOpenRouterKey;
